export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getBootScreenList: function getBootScreenList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/boot_screen/get",
        method: "get",
        params: data
      });
    },
    addBootScreen: function addBootScreen() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/boot_screen/create",
        method: "post",
        data: data
      });
    },
    updateBootScreen: function updateBootScreen() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/boot_screen/update",
        method: "post",
        data: data
      });
    },
    deleteBootScreen: function deleteBootScreen() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/boot_screen/delete",
        method: "post",
        data: data
      });
    },
    updateBootScreenStatus: function updateBootScreenStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/boot_screen/updateStatus",
        method: "post",
        data: data
      });
    },
    updateBootScreenConfig: function updateBootScreenConfig() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/boot_screen/updateConfig",
        method: "post",
        data: data
      });
    },
    getBootScreenConfig: function getBootScreenConfig() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/boot_screen/config",
        method: "get",
        params: data
      });
    }
  };
});